import { SocialLoginType } from "../helpers/Constants";

export enum GA_EVENTS {
  signup = 'sign_up',
  signupProgress = 'signup_progress',
  signupError = 'signup_error',
  signupSuccess = 'signup_success',
}

export type SignupEvent = {
  event: GA_EVENTS.signup;
  method: SocialLoginType | null;
  step_number?: undefined;
  step_name?: undefined;
  error_message?: undefined;
  role: string;
};

export type SignupProgressEvent = {
  event: GA_EVENTS.signupProgress;
  method?: undefined;
  step_number: number;
  step_name: string;
  error_message?: undefined;
  role?: undefined;
};

export type SignupErrorEvent = {
  event: GA_EVENTS.signupError;
  method?: undefined;
  step_number?: undefined;
  step_name?: undefined;
  role?: undefined;
  error_message: string;
};

export type SignupSuccessEvent = {
  event: GA_EVENTS.signupSuccess;
  method?: undefined;
  step_number?: undefined;
  step_name?: undefined;
  role?: undefined;
  error_message?: string;
};

export abstract class IAnalyticsDefinition {
  analyticsInstance: any;

  abstract init(analytics: any): void;
  abstract setUser(id: string): void;
  abstract logCustomEvent(
    params: SignupEvent | SignupErrorEvent | SignupProgressEvent | SignupSuccessEvent
  ): void;
}
